"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerReadiness = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ReadinessCheck = _interopRequireDefault(require("../ReadinessCheck"));
var _constants = require("../../../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SpeakerReadiness = exports.SpeakerReadiness = function SpeakerReadiness(_ref) {
  var status = _ref.status,
    onSpeakerStatusChanged = _ref.onSpeakerStatusChanged,
    hideBottomBorder = _ref.hideBottomBorder,
    showSpeakerTest = _ref.showSpeakerTest,
    onSetShowSpeakerTest = _ref.onSetShowSpeakerTest,
    presenterId = _ref.presenterId;
  var _useState = (0, _react.useState)(status),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    speakerStatus = _useState2[0],
    setSpeakerStatus = _useState2[1];
  var onConfirm = function onConfirm(isWorking) {
    if (isWorking) {
      setSpeakerStatus(_constants.PASSED);
      onSpeakerStatusChanged(_constants.PASSED);
    } else {
      setSpeakerStatus(_constants.FAILED);
      onSpeakerStatusChanged(_constants.FAILED);
    }
  };
  var onRetry = function onRetry() {
    setSpeakerStatus(_constants.CHECKING);
    onSpeakerStatusChanged(_constants.CHECKING);
  };
  return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement("div", null, "Loading audio file....")
  }, /*#__PURE__*/_react["default"].createElement(_ReadinessCheck["default"], {
    title: "Speaker",
    status: speakerStatus,
    onRetry: onRetry,
    onConfirm: onConfirm,
    failedText: 'Speaker output not working',
    hideBottomBorder: hideBottomBorder,
    showSpeakerTest: showSpeakerTest,
    onSetShowSpeakerTest: onSetShowSpeakerTest,
    presenterId: presenterId
  }, /*#__PURE__*/_react["default"].createElement("p", null, "Is the speaker device connected and turned on?"), /*#__PURE__*/_react["default"].createElement("p", null, "Is the volume for the speaker turned up?"), /*#__PURE__*/_react["default"].createElement("p", null, "Review and confirm your default system speaker device.")));
};
SpeakerReadiness.defaultProps = {
  status: _constants.CHECKING
};
SpeakerReadiness.propTypes = {
  status: _propTypes.string.isRequired,
  onSpeakerStatusChanged: _propTypes.func,
  hideBottomBorder: _propTypes.bool,
  showSpeakerTest: _propTypes.bool,
  onSetShowSpeakerTest: _propTypes.func,
  presenterId: _propTypes.string
};